import { useSearchParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowLeft, Phone } from 'lucide-react';
import { Button } from '@/components/ui/button';

const PaymentCancelPage = () => {
  const [searchParams] = useSearchParams();
  const consultationId = searchParams.get('consultation_id');

  return (
    <div className="min-h-screen bg-white py-20" data-testid="payment-cancel-page">
      <div className="max-w-2xl mx-auto px-4 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="bg-slate-50 rounded-2xl p-12"
        >
          <div className="w-20 h-20 bg-slate-200 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-10 h-10 text-slate-500" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900 mb-4">
            Pagamento annullato
          </h2>
          <p className="text-slate-600 mb-8">
            Il pagamento non è stato completato. La tua prenotazione è in attesa di conferma. 
            Puoi riprovare il pagamento o contattarci per assistenza.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/consulenza">
              <Button className="btn-accent" data-testid="retry-payment-btn">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Prenota nuovamente
              </Button>
            </Link>
            <Link to="/contatti">
              <Button variant="outline" data-testid="contact-btn">
                <Phone className="w-4 h-4 mr-2" />
                Contattaci
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
